import React from 'react'
import './account.css'
import SiteLayout from '../../component/layout/Layout'
import { Input, Button, Collapse } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import visaImg from '../../assets/img/Visa.svg'
import psLogo from '../../assets/img/ps-logo.svg'
import xboxLogo from '../../assets/img/xbox.svg'
import discordLogo from '../../assets/img/discord.svg'
import utubeLogo from '../../assets/img/youtube.svg'
import twLogo from '../../assets/img/twitch.svg'
import userLogo from '../../assets/img/user.svg'
import lockImg from '../../assets/img/lock.svg'
import infoImg from '../../assets/img/info.svg'
import arrow from '../../assets/img/back.svg'
import mail from '../../assets/img/mail.svg'
import trophy from '../../assets/img/trophy.svg'

const Account = () => {

    const { Panel } = Collapse;

    const accordionHeader = (
        <div className="accordion_header">
            <p>12:30 - 13:05</p>
            <p>0 changement</p>
            <Button>Confirmed</Button>
        </div>
    );

    return(
        <SiteLayout>
            <div className="account_body">
                <div className="top_bar">
                    <h2>Account</h2>
                </div>
                <div className="account_card_holder">
                            
                    <div className="fund_management">
                        <h4>FUND MANAGEMENT</h4>
                        <div className="account_card">
                            <Button type="primary">deposite</Button>
                            <hr />
                            <p>Biling method</p>
                            <div className="card_det">
                                <ul>
                                    <li>
                                        <img src={visaImg} alt=""/>
                                    </li>
                                    <li>5643 **** **** 3447</li>
                                    <li>Update</li>
                                </ul>
                                <p className="promo_code">Redeem Promo Code</p>
                                <p>Plan Details</p>
                            </div>
                            <div className="plan">
                                <h6>Standard Plan</h6>
                                <p>Change</p>
                            </div>
                        </div>
                    </div>

                    <div className="my_profile">
                        <h4>My profile</h4>
                        <div className="account_card">
                            <div className="user_det">
                                <div className="user_det_holder">
                                    <p>aimamisa@live.com</p>
                                    <span>Edit</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>Password: *********</p>
                                    <span>Change password</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>+234 - </p>
                                    <span>Edit</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>First Last</p>
                                    <span>Edit</span>
                                </div>
                                <hr />
                                <div className="user_det_holder">
                                    <p>aimamisa</p>
                                    <span>Edit Username</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>NG (IP: 192.168.8.1)</p>
                                    <span>Update country</span>
                                </div>
                                <hr />
                                <Button type="primary">Add Other ID</Button>
                                <div className="user_det_holder">
                                    <p>
                                        <img src={psLogo} alt="" style={{ width: '25px', marginRight: '5px' }}/>
                                        Awesome_nerrd
                                    </p>
                                    <span>Request PSN change</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>
                                        <img src={xboxLogo} alt="" style={{ width: '25px', marginRight: '5px' }}/>
                                        Stats_geek
                                    </p>
                                    <span>Request Gamertag change</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>
                                        <img src={discordLogo} alt="" style={{ width: '25px', marginRight: '5px' }}/>
                                        Stats_geek
                                    </p>
                                    <span>Request Discord ID change</span>
                                </div>
                                <p className="redeem_voucher">Redeem Vouchers</p>
                                <hr />
                                <p className="streaming_channel">My Streaming Channels</p>
                                <div className="user_det_holder">
                                    <p>
                                        <img src={utubeLogo} alt="" style={{ width: '45px', marginRight: '5px' }}/>
                                        https://youtube.com/4872…
                                    </p>
                                    <span>Edit</span>
                                </div>
                                <div className="user_det_holder">
                                    <p>
                                        <img src={twLogo} alt="" style={{ width: '20px', marginRight: '5px' }}/>
                                        https://twitch.ctv/awesome_nerrd
                                    </p>
                                    <span>Edit</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="my_leadership">
                        <h4>My Leaderboard</h4>
                        <div className="account_card">
                            <p>INDIVIDUAL</p>
                            <div className="table_responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>rank</th>
                                            <th>username</th>
                                            <th>points</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>21.</td>
                                            <td><img src={userLogo} alt=""/>  Shark_</td>
                                            <td>2310</td>
                                        </tr>
                                        <tr>
                                            <td>22.</td>
                                            <td><img src={userLogo} alt=""/>  Sadiqee99</td>
                                            <td>2311</td>
                                        </tr>
                                        <tr>
                                            <td>23.</td>
                                            <td><img src={userLogo} alt=""/>  Awesome_</td>
                                            <td>2312</td>
                                        </tr>
                                        <tr>
                                            <td>24.</td>
                                            <td><img src={userLogo} alt=""/>  Chibukor21</td>
                                            <td>2313</td>
                                        </tr>
                                        <tr>
                                            <td>25.</td>
                                            <td><img src={userLogo} alt=""/>  Obia_tiger</td>
                                            <td>2314</td>
                                        </tr>
                                        <tr>
                                            <td>26.</td>
                                            <td><img src={userLogo} alt=""/>  Truceee</td>
                                            <td>2315</td>
                                        </tr>
                                        <tr>
                                            <td>27.</td>
                                            <td><img src={userLogo} alt=""/>  Alice79</td>
                                            <td>2316</td>
                                        </tr>
                                        <tr>
                                            <td>28.</td>
                                            <td><img src={userLogo} alt=""/>  Gunfork</td>
                                            <td>2317</td>
                                        </tr>
                                        <tr>
                                            <td>29.</td>
                                            <td><img src={userLogo} alt=""/>  chi_square</td>
                                            <td>2318</td>
                                        </tr>
                                        <tr>
                                            <td>30.</td>
                                            <td><img src={userLogo} alt=""/>  Sunlit</td>
                                            <td>2319</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="friend_management">
                        <h4>Friends Management</h4>
                        <div className="account_card">
                            <Input placeholder="Filter friends…" />
                            <div className="table_responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>rank</th>
                                            <th>Member</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>21.</td>
                                            <td><img src={userLogo} alt=""/>  Shark_</td>
                                            <td>
                                                <Button className="follow">Following</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>22.</td>
                                            <td><img src={userLogo} alt=""/>  Sadiqee99</td>
                                            <td>
                                                <Button className="follow">Following</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>23.</td>
                                            <td><img src={userLogo} alt=""/>  Awesome_</td>
                                            <td>
                                                <Button className="follow">Following</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>24.</td>
                                            <td><img src={userLogo} alt=""/>  Chibukor21</td>
                                            <td>
                                                <Button className="request">Requested</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>25.</td>
                                            <td><img src={userLogo} alt=""/>  Obia_tiger</td>
                                            <td>
                                                <Button className="request">Requested</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>26.</td>
                                            <td><img src={userLogo} alt=""/>  Truceee</td>
                                            <td>
                                                <Button className="request">Requested</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>27.</td>
                                            <td><img src={userLogo} alt=""/>  Alice79</td>
                                            <td>
                                                <Button className="request">Requested</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>28.</td>
                                            <td><img src={userLogo} alt=""/>  Gunfork</td>
                                            <td>
                                                <Button className="rsent">Request Sent</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>29.</td>
                                            <td><img src={userLogo} alt=""/>  chi_square</td>
                                            <td>
                                                <Button className="rsent">Request Sent</Button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>30.</td>
                                            <td><img src={userLogo} alt=""/>  Sunlit</td>
                                            <td>
                                                <Button className="rsent">Request Sent</Button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="playing_activities">
                        <h4>Playing Activities & Rating</h4>
                        <div className="account_card playing_activities_account_card">
                        <Collapse
                        bordered={false}
                        // defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 45 : 0} />}
                        expandIconPosition='right'
                        className="site-collapse-custom-collapse"
                        accordion
                        >
                            <Panel header={accordionHeader} key="1" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                            <Panel header={accordionHeader} key="2" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                            <Panel header={accordionHeader} key="3" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                            <Panel header={accordionHeader} key="4" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                            <Panel header={accordionHeader} key="5" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                            <Panel header={accordionHeader} key="6" className="site-collapse-custom-panel">
                                <div className="timeline">
                                    <div className="time">
                                        <p>12:30 35 min.</p>
                                    </div>
                                    <div className="det">
                                        <div className="game_name">
                                            <p>Fifa 20</p>
                                            <hr />
                                            <MinusOutlined />
                                        </div>
                                        <div className="price">
                                            <h3>₦27,000</h3>
                                            <p>Winning prize</p>
                                            <img src={arrow} alt="" />
                                            <img src={mail} alt="" />
                                        </div>
                                        <div className="info">
                                            <p>Information</p>
                                            <p>Sport | Multiplayer</p>
                                        </div>
                                        <div className="rating">
                                            <div className="inner_rating">
                                                <img src={infoImg} alt="" />
                                                <p>New Rating Earned</p>
                                            </div>
                                        </div>
                                        <div className="win">
                                            <img src={trophy} alt="" />
                                            <p>Won</p>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                            </Panel>
                        </Collapse>
                        </div>
                    </div>

                    <div className="my_games">
                        <h4>My Games</h4>
                        <div className="account_card my_games_account_card">
                            <div className="header">
                                <h4>Upcoming Game</h4>
                            </div>
                            <div className="all_games_acc">

                                <div className="games">
                                    <div className="top">
                                        <p>Fifa 20: Standard Edition</p>
                                        <p>13:30 - 13:15</p>
                                    </div>
                                    <div className="bottom">
                                        <div className="cancel_edit">
                                            <Button type="primary">Cancel</Button>
                                            <p>Edit <img src={lockImg} alt=""/></p>
                                        </div>
                                        <div className="info">
                                            <p>
                                                <img src={infoImg} alt=""/>
                                                Rating: Lvl 2 Game
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            
                                <div className="games">
                                    <div className="top">
                                        <p>Fifa 20: Standard Edition</p>
                                        <p>13:30 - 13:15</p>
                                    </div>
                                    <div className="bottom">
                                        <div className="cancel_edit">
                                            <Button type="primary">Cancel</Button>
                                            <p>Edit <img src={lockImg} alt=""/></p>
                                        </div>
                                        <div className="info">
                                            <p>
                                                <img src={infoImg} alt=""/>
                                                Rating: Lvl 2 Game
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="games">
                                    <div className="top">
                                        <p>Fifa 20: Standard Edition</p>
                                        <p>13:30 - 13:15</p>
                                    </div>
                                    <div className="bottom">
                                        <div className="cancel_edit">
                                            <Button type="primary">Cancel</Button>
                                            <p>Edit <img src={lockImg} alt=""/></p>
                                        </div>
                                        <div className="info">
                                            <p>
                                                <img src={infoImg} alt=""/>
                                                Rating: Lvl 2 Game
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="games">
                                    <div className="top">
                                        <p>Fifa 20: Standard Edition</p>
                                        <p>13:30 - 13:15</p>
                                    </div>
                                    <div className="bottom">
                                        <div className="cancel_edit">
                                            <Button type="primary">Cancel</Button>
                                            <p>Edit <img src={lockImg} alt=""/></p>
                                        </div>
                                        <div className="info">
                                            <p>
                                                <img src={infoImg} alt=""/>
                                                Rating: Lvl 2 Game
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>

                    <div className="setting_notif">
                        <h4>Seting & Nofication</h4>
                        <div className="account_card">
                            <p>Test Participation</p>
                            <hr />
                            <p>Communication Setting</p>
                            <hr />
                            <p>Marketing Communication</p>
                            <hr />
                            <p>Notification Preference</p>
                            <hr />
                            <p>Language</p>
                            <hr />
                            <div className="bottom">
                                <p>Your Account</p>
                                <span>Signout of all device</span>
                            </div>
                        </div>
                    </div>
                       
                </div>
            </div>
        </SiteLayout>
    );
}

export default Account;